import React from 'react'
import PropTypes from 'prop-types'
import BaseIcon from '../../BaseIcon/BaseIcon'
import { ReactComponent as Component } from './SquareFacebook.svg'

const SquareFacebook = ({ className }) => {
	return <BaseIcon component={Component} className={className} viewBox="0 0 448 512" />
}

SquareFacebook.propTypes = {
	className: PropTypes.string,
}

export default SquareFacebook
